'use strict';

var MomentDateValidatorDirective = function MomentDateValidatorDirective(momentService) {
  return {
    require: 'ngModel',
    link: function link(scope, element, attrs, ctrl) {
      ctrl.$validators.invalidDate = function (modelValue, viewValue) {
        if (momentService.isMoment(viewValue)) {
          return viewValue.isValid();
        }
        return true;
      };
    }
  };
};
MomentDateValidatorDirective.$inject = ['MomentService'];
module.exports = MomentDateValidatorDirective;